import styled from "styled-components";

const Box = styled.div`
  background-color: ${(props) => props.backgroundColor || ""};
  border-radius: ${(props) => props.radius || 25} px;
`;

export default Box;
